import { get2DKeyHandler } from 't-lib-ui/structure';
import './OptionCard.css';

interface OptionCardProps {
  icon: React.ReactNode;
  title: string;
  description?: string;
  onClick: () => void;
  /** Highlights the card with the primary accent (like Home's "Quick start"). */
  primary?: boolean;
  className?: string;
}

// The icon + title + description card used across Home, Discover and Help. Joins the
// surrounding FlowForm's 2D spatial navigation (arrow keys move between cards, Enter/Space
// activates) via the standard flowFocussable/flow2d classes.
const cardKeyHandler = get2DKeyHandler((el: HTMLElement) => el.click());

const OptionCard: React.FC<OptionCardProps> = ({ icon, title, description, onClick, primary, className = '' }) => (
  <button
    type="button"
    tabIndex={0}
    className={`optionCard flowFocussable flow2d${primary ? ' optionCardPrimary' : ''} ${className}`.trim()}
    onClick={onClick}
    onKeyDown={cardKeyHandler}
  >
    <span className="optionCardIcon">{icon}</span>
    <span className="optionCardText">
      <span className="optionCardTitle">{title}</span>
      {description && <span className="optionCardDesc">{description}</span>}
    </span>
  </button>
);

export default OptionCard;
